import React, { useRef } from 'react';
import { ConnectedProps, connect } from 'react-redux';
import { Dispatch } from 'redux';
import { IStore } from '../../../../../redux/store';
import { TAnnex6HistoryFilters } from '../../../../../redux/app/annex6/@types';
import {
    annex6Actions,
    annex6Selectors,
} from '../../../../../redux/app/annex6';
import Annex6Print from './Annex6Print';
import Annex6CoverPage from './Annex6CoverPage';
import { useOnScrollToTop } from '../../../../../hooks/useScrollToTop';

type OwnProps = {
    showCoverPages?: boolean;
	vesselId: string;
};
type Annex6HistoryProps = PropsFromRedux & OwnProps;

function Annex6InspectorView(props: Annex6HistoryProps) {
    const { historyList, showCoverPages, vesselId } = props;
    const topDivRef = useRef<HTMLDivElement | null>(null);
    useOnScrollToTop(topDivRef);
    return (
        <div>
            <div className="h-0" ref={topDivRef} />
            {showCoverPages ? <Annex6CoverPage vesselId={vesselId}/> : null}
            <div className="newpage">
                <Annex6Print
                    key={'temp-print-id-annex6'}
                    isPrintVisible={true}
                    annex6Records={historyList}
					vesselId={vesselId}
                />
            </div>
        </div>
    );
}

function mapStateToProps(store: IStore, ownProps: OwnProps) {
    const annex6RecordStore = annex6Selectors._getStore(store);
    return {
        historyList: annex6Selectors.getHistoryList(annex6RecordStore),
        jobToLoadHistory: annex6Selectors.jobToLoadHistory(annex6RecordStore),
    };
}
function mapDispatchToProps(dispatch: Dispatch, ownProps: OwnProps) {
    return {
        load(filters: TAnnex6HistoryFilters) {
            return dispatch(annex6Actions.commands.historyLoad(filters));
        },
    };
}
const reduxConnector = connect(mapStateToProps, mapDispatchToProps);
type PropsFromRedux = ConnectedProps<typeof reduxConnector>;
export default reduxConnector(Annex6InspectorView);
